'use client'

import { createContext, useContext, useState, useMemo } from 'react'
// import { setClientCookie } from "@lib/cookies.client";

const defaultCity = typeof window !== 'undefined' ? localStorage.getItem('city') || 'delhi' : 'delhi'

const CityContext = createContext<{
  city: string
  setCity: (city: string) => void
}>({ city: defaultCity, setCity: () => {} })

export const CityProvider = ({ children }: { children: React.ReactNode }) => {
  const [city, setCityState] = useState(defaultCity)

  const changeCity = (newCity: string) => {
    localStorage.setItem('city', newCity)
    // setClientCookie("city", newCity);
    setCityState(newCity)
  }

  const value = useMemo(() => ({ city, setCity: changeCity }), [city])

  return <CityContext.Provider value={value}>{children}</CityContext.Provider>
}

export function useCity() {
  return useContext(CityContext)
}
